import { BaseMarkerRenderer } from '../base/baseMarkerRenderer'
import { RectangleMarker } from './rectangleMarker'
import { drawDashedSegment } from '../../helperFunctions'
import type p5 from 'p5'

interface DrawRectangleOptions {
  isDashed: boolean
  dashLength: number
  dashSpaceLength: number
}

function drawRectangle(gfx: p5, x: number, y: number, height: number, width: number, options?: DrawRectangleOptions) {
  if (options.isDashed) drawDashedRectangle(gfx, x, y, height, width, options.dashLength, options.dashSpaceLength)
  else drawSolidRectangle(gfx, x, y, height, width)
}

function drawSolidRectangle(gfx: p5, x: number, y: number, height: number, width: number) {
  gfx.rect(x, y, width, height)
}

function drawDashedRectangle(
  gfx: p5,
  x: number,
  y: number,
  height: number,
  width: number,
  dashLength: number,
  spaceLength: number
) {
  const segments = [
    { start: { x: x, y: y }, end: { x: x + width, y: y } }, // Top edge
    { start: { x: x + width, y: y }, end: { x: x + width, y: y + height } }, // Right edge
    { start: { x: x + width, y: y + height }, end: { x: x, y: y + height } }, // Bottom edge
    { start: { x: x, y: y + height }, end: { x: x, y: y } }, // Left edge
  ]

  segments.forEach((segment) => drawDashedSegment(gfx, segment, dashLength, spaceLength))
}

class RectangleMarkerRenderer extends BaseMarkerRenderer<RectangleMarker> {
  declare marker: RectangleMarker
  constructor(marker) {
    super(marker)
  }

  renderMarker(): void {
    const state = this.marker.state
    const isDashed = state.isDashed

    if (this.marker.isRectDefined()) {
      const gfx = this.marker.p
      const markerState = this.marker.state
      const x = markerState.position.x
      const y = markerState.position.y
      const height = markerState.dimensions.height
      const width = markerState.dimensions.width
      drawRectangle(gfx, x, y, height, width, {
        isDashed: isDashed,
        dashLength: markerState.dashLength,
        dashSpaceLength: markerState.dashSpaceLength,
      })
    }
  }
}

export { RectangleMarkerRenderer }
